import React, { Fragment } from 'react';
import { Header, Form, Radio } from 'semantic-ui-react';
import Field from '../Field';
import withVericationForm from './withVericationForm';
import yup from 'yup';
import DateInput from '../DateInput';

const ERROR_REQUIRED = 'This field is required';

class LegalFormalNoticeForm extends React.PureComponent {
  _onChange = (e, { name, value }) => {
    this.props.onChange(this.props.documentId, name, value || '');
  };

  render = () => {
    const { onBlur, values, errors, touched } = this.props;
    return (
      <Fragment>
        <Header>Legal Formal Notice</Header>
        <Form>
          <Field
            error={errors.languageOption}
            touched={touched.languageOption}
          >
            <p>Language </p>
            <Form.Field inline>
              <Radio
                label="English"
                name="languageOption"
                value="en"
                checked={values.languageOption === 'en'}
                onChange={this._onChange}
                onBlur={onBlur.bind(this, 'languageOption')}
              />
              <Radio
                label="French"
                name="languageOption"
                value="fr"
                checked={values.languageOption === "fr"}
                onChange={this._onChange}
                onBlur={onBlur.bind(this, 'languageOption')}
              />
            </Form.Field>
        </Field>
        <Field
          error={errors.sentDate}
          touched={touched.sentDate}
        >
          <DateInput
            date={values.sentDate}
            onChange={this._onChange}
            text="Date of sent"
            name="sentDate"
            inputWidth={4}
          />
        </Field>
      </Form>
    </Fragment>
    )
  }
}

const formikConfig = {
  mapPropsToValues: props => {
    return {...props.formValues}
  },
  validationSchema: () => {
    return yup.object().shape({
      languageOption: yup.string()
        .required(ERROR_REQUIRED),
      sentDate: yup.string()
        .required(ERROR_REQUIRED),
    })
  }
}

export default withVericationForm(formikConfig, ['languageOption', 'sentDate'])(LegalFormalNoticeForm)



// WEBPACK FOOTER //
// ./src/component/verification_forms/LegalFormalNoticeForm.js